import './ActionButton.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var disabled = '_1tm99w33-2-0-1';
export var navItem = _7a468({defaultClassName:'_1tm99w30-2-0-1',variantClassNames:{density:{'default':'_1tm99w31-2-0-1',condensed:'_1tm99w32-2-0-1'}},defaultVariants:{},compoundVariants:[]});
export var navItemSelectionStyle = '_1tm99w34-2-0-1';